import { TextField } from 'material-ui'
import MultiInput from '../multi-input'
import Schedule from './schedule'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

export default [
  { name: 'Name', prop: 'name', type: 'text' },
  {
    name: 'Session',
    prop: 'session_id',
    type: 'autocomplete',
    references: 'admin/sessions',
    referenceProp: 'name',
    displayProp: 'long_name',
    rejectCustomValues: true
  },
  {
    name: 'Group',
    prop: 'group_id',
    type: 'autocomplete',
    references: 'admin/groups',
    referenceProp: 'name',
    displayProp: 'name',
    rejectCustomValues: true
  },
  {
    name: 'Frequency',
    prop: 'schedules',
    type: 'component',
    component: Schedule
  },
  { name: 'Send comment to members who haven\'t checked in', prop: 'include_not_checked_in_users', type: 'checkbox' },
  { name: 'Send comment to members who have checked in', prop: 'include_checked_in_users', type: 'checkbox' },
  [
    { name: 'Start Date', prop: 'start_date', type: 'date' },
    { name: 'End Date', prop: 'end_date', type: 'date' }
  ],
  {
    name: 'Who is sending this reminder?',
    prop: 'user_id',
    type: 'autocomplete',
    dataHydrator: userEmailHydrator,
    references: 'admin/users',
    referenceProp: 'name',
    displayProp: 'displayVal'
  },
  {
    name: 'Comment Variations',
    prop: 'comment_variations',
    type: 'component',
    component: MultiInput,
    componentProps: {
      addItemText: '+ Add More Variations',
      onAdd: (ref) => ref && ref.focus(),
      minItems: 1,
      component: TextField,
      componentProps: {
        multiLine: true,
        required: true
      }
    }
  }
]
